if (typeof document !== 'undefined') {
  throw new Error("config.js doesn't work in client-side code");
}
var nodeEnv = process.env.NODE_ENV || 'production';
var envType = nodeEnv === 'production' ? 'Production' : 'Development';
var roleType = process.env.ROLE_TYPE || 'Public';
var parseBooleanEnvVar = function parseBooleanEnvVar(envVar, defaultValue) {
  if ((envVar === null || envVar === void 0 ? void 0 : envVar.toLowerCase()) === 'true') return true;
  if ((envVar === null || envVar === void 0 ? void 0 : envVar.toLowerCase()) === 'false') return false;
  return defaultValue;
};
module.exports = {
  env: process.env.NODE_ENV || 'production',
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || 8080,
  prismicAccessToken: process.env.PRISMIC_TOKEN,
  prismicApiEndpoint: 'https://milanote.cdn.prismic.io/api',
  staticPath: process.env.STATIC_PATH || 'http://localhost:8081',
  appUrl: process.env.APP_URL || 'http://localhost:3000',
  publicSiteUrl: process.env.PUBLIC_SITE_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://milanote.com'),
  cookieDomain: process.env.COOKIE_DOMAIN || 'localhost',
  s3ReleaseBucketUrl: process.env.S3_RELEASE_BUCKET_URL || 'https://releases.milanote.com',
  analytics: {
    enabled: process.env.NODE_ENV === 'production' || process.env.ANALYTICS_ENABLED === 'true',
    googleAnalyticsCode: process.env.GA_CODE || 'UA-79433617-1',
    googleTagManagerCode: process.env.GTM_CODE || 'GTM-54XWBQ4',
    googleTagManagerContainerInfo: process.env.NODE_ENV === 'production' ? '' : '&gtm_auth=TZOqGV9YxtmVrxJY98NSVA&gtm_preview=env-89&gtm_cookies_win=x'
  },
  intercom: {
    enabled: process.env.NODE_ENV === 'production' || process.env.ANALYTICS_ENABLED === 'true',
    // Intercom token for user tracking and messaging (SENSITIVE - DO NOT SHARE or output in client-side config)
    token: process.env.INTERCOM_TOKEN || ''
  },
  appStore: {
    iOSAppId: 1433852790
  },
  newrelic: {
    enabled: parseBooleanEnvVar(process.env.NEW_RELIC_ENABLED, true),
    appName: ["".concat(envType, "_").concat(roleType)],
    licenseKey: process.env.NEW_RELIC_LICENSE_KEY || '',
    labels: "label.Environment:".concat(envType, ";label.Role:").concat(roleType),
    distributedTracingEnabled: true
  }
};